import { SUBSCRIPTION_FREQUENCY } from '@urc-ui/utils/types';
import { SCHEDULE_FREQUENCY } from '@urc-ui/store/api/ross/constants/schedule-constants';

export const RECURRING_SCHEDULE_FREQUENCY_MAP: Record<string, SCHEDULE_FREQUENCY> = {
  [SUBSCRIPTION_FREQUENCY.MONTHLY_DATE]: SCHEDULE_FREQUENCY.MONTHLY
};

export const RECURRING_SCHEDULE_FREQUENCY_MAP_ROSS_TO_SSPA: Record<string, string> = {
  [SCHEDULE_FREQUENCY.ONE_TIME]: SUBSCRIPTION_FREQUENCY.SINGLE,
  [SCHEDULE_FREQUENCY.MONTHLY]: SUBSCRIPTION_FREQUENCY.MONTHLY_DATE
};

export const SORT_COLUMN_MAP: Record<string, string> = {
  SUBSCRIPTION_NAME: 'Name',
  SUBSCRIPTION_STATUS: 'Status',
  SUBSCRIPTION_AUDIT_MODIFIED_ON: 'ModifiedOn'
};

export const SORT_DIRECTION_MAP: Record<string, string> = {
  ASC: 'Asc',
  DESC: 'Desc'
};
